import { Button, type ButtonProps, useTheme } from '@chakra-ui/react'

import { useAppTheme } from '@core/utils/contexts/ThemeContext/ThemeContext'
import { hexColorEffect } from '@core/utils/helpers/hexColorEffect'
import { forwardRef } from 'react'

type AppButtonProps = ButtonProps & {
    label?: string
    variant?: 'primary' | ButtonProps['variant']
}

export const AppButton = forwardRef<HTMLButtonElement, AppButtonProps>((props, ref) => {
    const { appTheme } = useAppTheme()
    const theme = useTheme()

    const fallbackPrimaryBg = '#2F80ED'
    const fallbackPrimaryHoverBg = '#529CFF'
    const fallbackPrimaryColor = '#FFFFFF'

    let primaryColor = theme?.colors?.text?.white ?? fallbackPrimaryColor
    let primaryBg = theme?.colors?.btn?.primaryDefault ?? fallbackPrimaryBg
    let primaryHoverBg = theme?.colors?.btn?.primaryHover ?? fallbackPrimaryHoverBg

    if (appTheme) {
        primaryColor = appTheme?.newSettings?.general?.ButtonText
            ? `#${appTheme?.newSettings?.general?.ButtonText}`
            : (theme?.colors?.text?.white ?? fallbackPrimaryColor)

        primaryBg = appTheme?.newSettings?.general?.ButtonBackground
            ? `#${appTheme?.newSettings?.general?.ButtonBackground}`
            : (theme?.colors?.btn?.primaryDefault ?? fallbackPrimaryBg)

        primaryHoverBg = hexColorEffect(primaryBg, 30)
    }

    if (props.variant === 'primary') {
        return (
            <Button
                ref={ref}
                {...props}
                title={props.label}
                color={primaryColor}
                bg={primaryBg}
                _hover={{ backgroundColor: primaryHoverBg }}
                aria-label={props.label}
            >
                {props.children ?? props.title}
            </Button>
        )
    }

    return (
        <Button ref={ref} {...props} aria-label={props.label} title={props.label}>
            {props.children ?? props.title}
        </Button>
    )
})

// export const AppButton = ({ ...props }) => {
//     const { appTheme } = useAppTheme()
//     const theme = useTheme()
//     const fallbackPrimaryBg = '#2F80ED'
//     const fallbackPrimaryHoverBg = '#529CFF'
//     const fallbackPrimaryColor = '#FFFFFF'
//
//     let primaryColor = theme?.colors?.text?.white ?? fallbackPrimaryColor
//     let primaryBg = theme?.colors?.btn?.primaryDefault ?? fallbackPrimaryBg
//     let primaryHoverBg = theme?.colors?.btn?.primaryHover ?? fallbackPrimaryHoverBg
//
//     if (appTheme) {
//         primaryColor = appTheme?.newSettings?.general?.ButtonText
//             ? `#${appTheme?.newSettings?.general?.ButtonText}`
//             : theme?.colors?.text?.white ?? fallbackPrimaryColor
//         primaryBg = appTheme?.newSettings?.general?.ButtonBackground
//             ? `#${appTheme?.newSettings?.general?.ButtonBackground}`
//             : theme?.colors?.btn?.primaryDefault ?? fallbackPrimaryBg
//         primaryHoverBg = hexColorEffect(primaryBg, 30)
//     }
//
//     if (props.variant === 'primary') {
//         return (
//             <Button
//                 {...props}
//                 title={props.label}
//                 color={props.variant === 'primary' ? primaryColor : props.color}
//                 bg={props.variant === 'primary' ? primaryBg : props.bg}
//                 _hover={{ backgroundColor: props.variant === 'primary' && primaryHoverBg }}
//                 aria-label={props.label}
//             >
//                 {props.children ?? props.title}
//             </Button>
//         )
//     } else {
//         return (
//             <Button {...props} aria-label={props.label} title={props.label}>
//                 {props.children ?? props.title}
//             </Button>
//         )
//     }
// }
